import { makeStyles } from '@material-ui/core/styles';
import AssistantIcon from '@material-ui/icons/Assistant';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectArrayInput,
    CustomSelectInput,
} from 'candy-commons-components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
    BooleanInput,
    DateInput,
    Edit,
    FormDataConsumer,
    SimpleForm,
    TextInput,
    required,
    useTranslate,
} from 'react-admin';
import CustomToolbar from '../../components/CustomToolbar';
import PAGE_CONTENTS from '../../data/newFeaturesBannerPageOptions.json';
import { getApplianceTypes, getBrands } from '../../selectors/cmsConfig';
const NewFeaturesBannerEdit = ({ permissions = {}, ...props }) => {
    const classes = useStyles();
    const [allApplianceFlag, setAllApplianceFlag] = useState(false);
    const [allBrandFlag, setAllBrandFlag] = useState(false);
    const { id } = props;
    const translation = useTranslate();
    const isEditDisabled = !permissions?.['new-features-banner']?.update;
    const brands = useSelector(getBrands);
    const applianceTypes = useSelector(getApplianceTypes);
    const breadcrumbsData = [
        {
            text: translation('resources.new-features-banner.name'),
            url: 'new-features-banner',
            icon: <AssistantIcon />,
        },
        {
            text: id,
            url: '',
        },
    ];
    const handleAllAppliance = (e) => setAllApplianceFlag(e.target.checked);
    const handleAllBrand = (e) => setAllBrandFlag(e.target.checked);
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Edit className={classes.reverseButtonSave} {...props}>
                <SimpleForm
                    toolbar={
                        <CustomToolbar
                            permissions={permissions}
                            isEditDisabled={isEditDisabled}
                        />
                    }
                >
                    <ContainerFieldsList>
                        <TextInput
                            label="Title"
                            source="title"
                            validate={required()}
                        />
                        <TextInput label="Description" source="description" />
                        <CustomSelectInput
                            label="Page content"
                            source="pageContent"
                            validate={required()}
                            choices={PAGE_CONTENTS}
                            helperText="Ecommerce homepage: use one pair per brand (HAIER / CANDY / HOOVER). The app shows them for the brand selected by the user."
                        />
                        <DateInput
                            source="validFrom"
                            label="Valid from"
                            validate={required()}
                        />
                        <DateInput
                            source="validTo"
                            label="Valid to"
                            validate={required()}
                        />
                        <TextInput label="Image 24x24" source="image" />
                        <TextInput label="Deeplink" source="deeplink" />
                        {/* <TextInput
                            label="Description"
                            source="description"
                            validate={required()}
                        />
                        <TextInput label="Color es:#000" source="color" /> */}
                    </ContainerFieldsList>
                    <ContainerFieldsList>
                        <FormDataConsumer>
                            {({ formData }) => (
                                <>
                                    {!formData.AllAppliance &&
                                        !allApplianceFlag && (
                                            <CustomSelectArrayInput
                                                label="Appliance types"
                                                source="applianceType"
                                                choices={applianceTypes}
                                                validate={required()}
                                                disabled={
                                                    allApplianceFlag ||
                                                    isEditDisabled
                                                }
                                            />
                                        )}
                                    <BooleanInput
                                        label="All appliance"
                                        source="isAllAppliance"
                                        disabled={
                                            formData.NoAppliance ||
                                            isEditDisabled
                                        }
                                        onClick={handleAllAppliance}
                                    />
                                </>
                            )}
                        </FormDataConsumer>
                    </ContainerFieldsList>
                    <ContainerFieldsList>
                        <FormDataConsumer>
                            {({ formData }) => (
                                <>
                                    {!formData.allBrandFlag &&
                                        !allBrandFlag && (
                                            <CustomSelectArrayInput
                                                label="Brand"
                                                source="brand"
                                                validate={required()}
                                                choices={brands.filter(
                                                    (br) => br.id !== 'all'
                                                )}
                                            />
                                        )}
                                    <BooleanInput
                                        label="All brand"
                                        initialValue={false}
                                        source="isAllBrand"
                                        onClick={handleAllBrand}
                                    />
                                </>
                            )}
                        </FormDataConsumer>
                    </ContainerFieldsList>
                </SimpleForm>
            </Edit>
        </>
    );
};
const useStyles = makeStyles({
    reverseButtonSave: {
        '& .MuiToolbar-root>div': {
            flexDirection: 'row-reverse',
        },
    },
});
export default NewFeaturesBannerEdit;
